import { render, staticRenderFns } from "./ExerciseIcon.vue?vue&type=template&id=4823150f&scoped=true&"
import script from "./ExerciseIcon.vue?vue&type=script&lang=js&"
export * from "./ExerciseIcon.vue?vue&type=script&lang=js&"
import style0 from "./ExerciseIcon.vue?vue&type=style&index=0&id=4823150f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4823150f",
  null
  
)

export default component.exports